@file:Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")

package com.wintermar.inspection.feature.domain.usecase.reference

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.feature.domain.model.VesselModel
import com.wintermar.inspection.feature.domain.repository.ReferenceRepository
import kotlinx.coroutines.flow.Flow

actual class GetListVesselUseCaseImpl actual constructor(
    val referenceRepository: ReferenceRepository
) : GetListVesselUseCase {
    actual override operator fun invoke(): Flow<FlowResult<List<VesselModel>>> {
        return referenceRepository.getVesselList()
    }
}
